import Keycloak, { type KeycloakConfig } from 'keycloak-js';
import type { AuthConfig } from '../config/types';

export function createKeycloak(config: AuthConfig): Keycloak {
  const kcConfig: KeycloakConfig = {
    url: config.keycloakUrl,
    realm: config.realm,
    clientId: config.clientId
  };
  return new Keycloak(kcConfig);
}

export interface AuthUser {
  id: string;
  username: string;
  email?: string;
  name?: string;
  roles: string[];
  rawToken?: string;
}

export function userFromKeycloak(kc: Keycloak): AuthUser | null {
  if (!kc.tokenParsed || !kc.subject) return null;
  const tp = kc.tokenParsed as Record<string, unknown>;
  return {
    id: kc.subject,
    username: (tp.preferred_username as string) ?? '',
    email: tp.email as string | undefined,
    name: tp.name as string | undefined,
    // ADR-023 §3 — `roles` is a top-level claim populated by the
    // group-membership protocol mapper.
    roles: ((tp.roles as string[]) ?? []),
    rawToken: kc.token
  };
}
